import { MutableRefObject } from "react";
import NumberFormat, { NumberFormatPropsBase } from "react-number-format";

type InheritedNumberProps = Omit<
  NumberFormatPropsBase,
  "name" | "value" | "onChange"
>;

export interface NumberInputProps extends InheritedNumberProps {
  inputRef?: MutableRefObject<HTMLInputElement | null>;
  name: string;
  value: number | null;
  onChange(value: number | null): void;
}

export function NumberInput({
  inputRef,
  name,
  value,
  onChange,
  ...props
}: NumberInputProps) {
  return (
    <NumberFormat
      {...props}
      getInputRef={
        inputRef ? (ref: HTMLInputElement) => (inputRef.current = ref) : null
      }
      name={name}
      type="text"
      thousandSeparator={" "}
      isNumericString={true}
      value={value === null || value === undefined ? "" : value.toString()}
      onChange={(event) => {
        onChange(
          event.target.value
            ? parseFloat(event.target.value.replace(/\s/g, ""))
            : null
        );
      }}
    />
  );
}
